import { ICapabilities, CapabilitiesType } from '../types/capabilties'
import { types } from '../types/capabilties'

export const initialState: ICapabilities = {
  isLoading: false,
  list: [],
}

export const capabilities = (
  state = initialState,
  action: CapabilitiesType
): ICapabilities => {
  switch (action.type) {
    case types.GET_CAPABILITIES__STARTED:
      return { ...initialState, isLoading: true }
    case types.GET_CAPABILITIES__SUCCESS:
      return { ...state, isLoading: false, list: action.list || [] }
    case types.GET_CAPABILITIES__FAILURE:
      return { ...state, isLoading: false }
    default:
      return state
  }
}
